import { Form, Formik } from "formik";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import { useState } from "react";
import Callout from "../UI/Callout";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { handleAPIError } from "../../utils/index.jsx";
import { actionIV, actionValidationSchema } from "../../models/action";
import TextInput from "../UI/TextInput";

export default function ActionForm({ action, ModalElement, onSubmit }) {
  const [error, setError] = useState("");

  const initialValues = toInitialValuesFromSchema(
    actionValidationSchema,
    action,
    actionIV,
  );

  async function submitHandler(values, { resetForm }) {
    setError("");
    try {
      await onSubmit(actionValidationSchema.cast(sanitizeValues(values)));
      resetForm();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={actionValidationSchema}
      onSubmit={submitHandler}
    >
      {({ resetForm }) => (
        <ModalElement
          size={"small"}
          onClose={() => {
            resetForm();
            setError("");
          }}
        >
          <p className={"cardTitle text-center marginB20"}>
            <img
              src={`/photo_balance.png`}
              alt="Balance locataire"
              className={"center"}
            />
            Nombre de jour avant / après l'échéance
          </p>
          <Form>
            <TextInput
              type={"number"}
              name={"meta.delai"}
              label={"Nombre de jour"}
            />
            <div className={"text-right"}>
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </div>
            <Callout variant="danger">{error}</Callout>
          </Form>
        </ModalElement>
      )}
    </Formik>
  );
}
